<template>
  <div id="app">
    <!-- Login Screen -->
    <Login v-if="!isAuthenticated" @authenticated="handleAuthenticated" />

    <!-- Upscaler Screen (shown after login) -->
    <Upscaler v-else-if="isAuthenticated" />

    <!-- Pod Status Widget (always visible after login) -->
    <PodStatus v-if="isAuthenticated" />

    <!-- Logout Menu -->
    <Logout v-if="isAuthenticated" @logout="handleLogout" />
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';
  import Login from './components/Login.vue';
  import Upscaler from './components/Upscaler.vue';
  import PodStatus from './components/PodStatus.vue';
  import Logout from './components/Logout.vue';
  import { upscalerPod } from './services/upscale.service.js';
  import { useTokenService } from './composables/useTokenService.js';

  const isAuthenticated = ref<boolean>(false);

  const tokenService = useTokenService();

  const handleAuthenticated = () => {
    console.log('[App] User authenticated');
    isAuthenticated.value = true;
  };

  const handleLogout = () => {
    tokenService.clearToken();
    console.log('[App] User logged out');
    isAuthenticated.value = false;
  };

  const initializeApp = async () => {
    isAuthenticated.value = await upscalerPod.validateToken(tokenService.getToken() || '');
  };

  onMounted(initializeApp);
</script>

<style scoped>
  #app {
    background: var(--background);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-family: 'Poppins', sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
